
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'Loading'
})
export default class Loading extends Vue {
  @Prop({ type: String, default: '' }) private text!: string;
  @Prop({ type: String, default: '#F0F0F0' }) private color!: string;
  @Prop({ type: String, default: '24px' }) private fontSize!: string;
  @Prop({ type: Boolean, default: false }) private isVisible!: boolean;
  @Prop({ type: String, default: 'fade' }) private transition!: string;
  @Prop({ type: Boolean, default: false }) private isSmall!: boolean;
  @Prop({ type: Boolean, default: true }) private isFullScreen!: boolean;
};
